<script setup>
    const props = defineProps({
        headingText: {
            type: String,
            required: true
        },
        subText: {
            type: String,
            required: true
        },
    })

</script>
<template>
    <div class="w-full max-w-sm md:max-w-md lg:max-w-lg xl:max-w-5xl flex flex-col items-center justify-center">
        <div class="text-2xl mb-2 text-center font-medium text-primary-font">
            {{headingText}}
        </div>
        <div class="text-sm text-center text-primary-gray">
            {{subText}}
        </div>
    </div>
</template>